import React, {useEffect} from "react";
import {Form, Input} from "antd";
import {useDispatch, useSelector} from "react-redux";
import {userSignIn, setSignInError} from "../appRedux/actions/Auth";
import {getUser} from "../appRedux/actions";
import {Link, useNavigate} from "react-router-dom";
import "./SignIn.css"; // Import the CSS file we'll create

const SignIn = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const token = useSelector(({auth}) => auth.token);
  const loggedInUser = useSelector(({user}) => user.loggedInUser);
  let invalidCredentials = useSelector(state => state.auth.invalidCredentials);

  const onFinishFailed = errorInfo => {
    console.log('Failed:', errorInfo);
  };

  const onFinish = values => {
    dispatch(userSignIn(values));
  };

  const handlePasswordChange = () => {
    dispatch(setSignInError());
  };

  const handleDeleteCaches = async () => {
    try {
      const cacheNames = await caches.keys();
      const deletePromises = cacheNames.map(cacheName => caches.delete(cacheName));
      await Promise.all(deletePromises);
    } catch (error) {
      console.error('Error deleting caches:', error);
    }
  };

  useEffect(() => {
    handleDeleteCaches();
    if (token !== null) {
      navigate('/');
    }
  }, [token, navigate]);

  useEffect(() => {
    if (token !== null && !loggedInUser) {
      dispatch(getUser());
    }
  }, [token, dispatch, loggedInUser]);

  return (
    <div className="stell-login-wrapper">
      <div className="stell-login-container">
        {/* Ambient background glow circles */}
        <div className="stell-ambient-glow" aria-hidden="true">
          <div className="stell-glow-circle stell-glow-left"></div>
          <div className="stell-glow-circle stell-glow-right"></div>
        </div>

        {/* Card */}
        <div className="stell-card-wrapper">
          <div className="stell-card-grid">
            
            {/* LEFT PANEL */}
            <div className="stell-left-panel">
              <div className="stell-panel-border"></div>
              <div className="stell-left-content">
                
                {/* Logo */}
                <div className="stell-logo-section">
                  <div className="stell-logo-icon">
                    {/* <svg width="36" height="36" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <rect x="2" y="2" width="20" height="20" rx="4" fill="#ffffff" opacity="0.06"/>
                      <path d="M5 12C5 8 8 5 12 5" stroke="#fff" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/>
                      <path d="M19 12C19 16 16 19 12 19" stroke="#fff" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg> */}
                    <img alt="example" src={require("assets/images/logo.png")}/>
                  </div>
                  {/* <div className="stell-logo-text">
                    <div>Stell<br/>One</div>
                  </div> */}
                </div>

                {/* Heading */}
                <h1 className="stell-heading">Welcome to Stell One</h1>
                <p className="stell-subheading">Your workspace to manage everything smartly.</p>
                <p className="stell-login-prompt">Log in to continue...</p>

                {/* Bottom border glow */}
                <div className="stell-bottom-glow"></div>
              </div>
            </div>

            {/* RIGHT PANEL */}
            <div className="stell-right-panel">
              <div className="stell-form-wrapper">
                <Form
                  initialValues={{remember: true}}
                  name="basic"
                  onFinish={onFinish}
                  onFinishFailed={onFinishFailed}
                  className="stell-signin-form"
                >
                  <Form.Item
                    rules={[{required: true, message: 'Please input your username or email!'}]}
                    name="username"
                  >
                    <Input
                      placeholder="Username or email"
                      className="stell-input"
                      size="large"
                    />
                  </Form.Item>

                  <Form.Item
                    className={`${invalidCredentials && "stell-input-error"}`}
                    rules={[{required: true, message: 'Please input your Password!'}]}
                    name="password"
                  >
                    <Input.Password
                      placeholder="Password"
                      onChange={() => handlePasswordChange()}
                      className="stell-input"
                      size="large"
                    />
                  </Form.Item>

                  {invalidCredentials && (
                    <div className="stell-error-message" role="alert">
                      Sign-in unsuccessful. Please try again.
                    </div>
                  )}

                  <Form.Item>
                    <button type="submit" className="stell-submit-btn">
                      Sign In
                    </button>
                  </Form.Item>

                  <div className="stell-forgot-link">
                    <Link to="/forgot-password">
                      Forgot Password?
                    </Link>
                  </div>
                </Form>
              </div>

              {/* Subtle card inner shadow */}
              <div className="stell-panel-shadow"></div>
            </div>
          </div>

          {/* Outer glow at bottom */}
          <div className="stell-card-bottom-glow"></div>
        </div>
      </div>
    </div>
  );
};

export default SignIn;